import type { DemoScenarioResolved } from 'tio-data/demo/types';
import type { DemoProductConfig, DemoScenario } from 'tio-employee/demo/types';

/** Contributions demo builder. Scaffolding — filled in a later phase. */
export function buildContributionsDemo(
  _config: Extract<DemoProductConfig, { kind: 'contributions' }>,
  _scenario: DemoScenario
): DemoScenarioResolved {
  return { matchers: [], seed: [] };
}
